export default {"src":"/_next/static/media/dv_icon_black.02515256.svg","height":12,"width":9,"blurWidth":0,"blurHeight":0};